import React from "react";
import "./CarCard.css";
import PersonIcon from "@mui/icons-material/Person";
import FrontLoaderIcon from "@mui/icons-material/FrontLoader";
import DeviceHubIcon from "@mui/icons-material/DeviceHub";
import { Chip, Skeleton } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Text } from "@shopify/polaris";
import { formatPlate } from "../../utility/funcs";

function CarCard({ car, selected, onClick, loading = false, warning = null }) {
  if (loading) {
    return (
      <div className="car_card_skeleton">
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={"100%"}
          sx={{ borderRadius: "4px" }}
          animation="wave"
        />
      </div>
    );
  }
  const getSelectedStatus = () => {
    if (selected === undefined) {
      return "";
    }
    return selected === car.id ? "selected" : "unselected";
  };
  return (
    <div
      className={`car_card_container ${getSelectedStatus()}`}
      onClick={() => {
        onClick({ car: car.id, model: car.model_id });
      }}
      key={car.id}
    >
      <Text>
        {car.brand} {car.show_as || car.model}
      </Text>
      <Text variant="headingMd">{formatPlate(car.plate)}</Text>
      <Text>
        {car.color} {car.year}
      </Text>
      {warning && (
        <div className="car_card_warning" title={warning}>
          ↻ {warning}
        </div>
      )}
      <div className="car_card_chips">
        {!car.passengers || (
          <>
            <Chip
              variant="outlined"
              size="small"
              icon={<PersonIcon />}
              label={`${car.passengers}p`}
              className="car_card_chip"
            />
          </>
        )}
        {!car.weight_capacity || (
          <>
            <Chip
              variant="outlined"
              size="small"
              icon={<FrontLoaderIcon />}
              label={`${car.weight_capacity}kg`}
              className="car_card_chip"
            />
          </>
        )}
        {!car.transmission || (
          <>
            <Chip
              variant="outlined"
              size="small"
              icon={<DeviceHubIcon />}
              label={`${car.transmission.substring(0, 3)}`}
              className="car_card_chip"
            />
          </>
        )}
      </div>
      {selected !== car.id || (
        <CheckCircleIcon className="selected_check_indicator" color="success" />
      )}
    </div>
  );
}

export default CarCard;
